export default fields_grouped_by_section =>
  fields_grouped_by_section.reduce((sections, section) => {
    sections.push(...section.fields);
    return sections;
  }, []);
